import type { TranslationTag } from '@ps/web-core-intl';
import type { ReactNode } from 'react';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { useRegulatoryOverride } from '../hooks/useRegulatoryOverride/useRegulatoryOverride';
import {
  type Options,
  useTranslationValues
} from '../hooks/useTranslationValues/useTranslationValues';

export interface Props extends TranslationTag, Options {
  tagName?: React.ElementType;
  children?(...nodes: ReactNode[]): React.ReactElement | null;
}

const HtmlValues: React.ComponentProps<typeof FormattedMessage>['values'] = {
  span: (...chunks: ReactNode[]) => <span>{React.Children.toArray(chunks)}</span>,
  strong: (...chunks: ReactNode[]) => <strong>{React.Children.toArray(chunks)}</strong>,
  b: (...chunks: ReactNode[]) => <b>{React.Children.toArray(chunks)}</b>,
  a: (link: ReactNode, ...chunks: ReactNode[]) => (
    <a href={link as string}>{React.Children.toArray(chunks)}</a>
  ),
  u: (...chunks: ReactNode[]) => <u>{React.Children.toArray(chunks)}</u>,
  ol: (...chunks: ReactNode[]) => <ol>{React.Children.toArray(chunks)}</ol>,
  li: (...chunks: ReactNode[]) => <li>{React.Children.toArray(chunks)}</li>,
  br: (..._chunks: ReactNode[]) => <br />
};

const Translation: React.FC<Props> = ({ resolve, domain, values, ...rest }) => {
  const allValues = useMemo(() => ({ ...HtmlValues, ...values }), [values]);
  const overrideTranslation = useRegulatoryOverride(rest);

  return (
    <FormattedMessage
      {...rest}
      {...overrideTranslation}
      values={useTranslationValues({
        resolve,
        domain,
        values: allValues
      })}
    />
  );
};

export default Translation;
